import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { PublicClientService } from "@nexu-library/utilities";

@Injectable()
export class PublicAuthInterceptor implements HttpInterceptor {
  constructor(private _publicClientService: PublicClientService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if ((error.status === 401 || error.status === 403) && request.url.includes("/api/public/")) {
          return this._publicClientService.login().pipe(
            switchMap((response) => {
              localStorage.setItem("api_key", response.access_token);
              return next.handle(
                request.clone({
                  headers: request.headers.set("Authorization", `Bearer ${response.access_token}`),
                })
              );
            })
          );
        } else {
          return throwError(error);
        }
      })
    );
  }
}
